import {observable, action, computed, ObservableMap, makeObservable, observe} from 'mobx';
import {ProcedureRequester} from "./RequestApi/ProcedureRequester";
import {GeneralRequester} from "./RequestApi/GeneralRequester";
import {permissionsEnum, accessItemTypeEnum} from "../serverClientShared/sharedEnums";

export class GuidesUploadStore {
    procedureToUpload = [];
    progress = [];
    statusArray = [];
    isLoading = false;
    startUploading = false;
    beforeUploading = true;
    doneUploading = false;
    procedureHovered = [];
    urlData = {};
    associatedFiles = [];
    finishedFilesCount = 0;
    notCanceledFilesCount = 0
    linearLoaderValue = 0;
    isFailedOrCanceledProgress = false
    isSuccess = false
    noPermissionModal = false
    isCheckingPermissions = false

    constructor(modalStore, generalStore, projectStore) {
        makeObservable(this, {
            procedureToUpload: observable,
            progress: observable,
            statusArray: observable,
            isLoading: observable,
            startUploading: observable,
            beforeUploading: observable,
            doneUploading: observable,
            procedureHovered: observable,
            urlData: observable,
            associatedFiles: observable,
            finishedFilesCount: observable,
            notCanceledFilesCount: observable,
            linearLoaderValue: observable,
            isFailedOrCanceledProgress: observable,
            isSuccess: observable,
            noPermissionModal: observable,
            isCheckingPermissions: observable,
            cancelUploadingAll: action,
            checkIfDoneUploading: action,
            updateProgress: action,
            getInitData: action,
            checkPermission: action,
            closeProcess: action,
        });
        this.modalStore = modalStore;
        this.generalStore = generalStore;
        this.projectStore = projectStore;

    }

     cancelUploadingAll= async () => {
        const isProcessFinished = this.progress.some(p => p === 100)
         const filesToCancel = this.associatedFiles.filter((file, i) => this.progress[i] < 100)
        const projectId = this.projectStore.currentProject?.ProjectIdentifier;
        const result = await ProcedureRequester.cancelConvertGuideProcess(this.generalStore.workspace, filesToCancel, !isProcessFinished, projectId)
         this.progress = this.progress.map((p, i) => p === 100? 100 : 101)
        this.checkIfDoneUploading(this.progress, [])
    }

    checkIfDoneUploading = (progressArray, isCanceledArray) => {
        if (progressArray.length === 0) return false;
        const allDone = progressArray.every((progress, i) =>
            progress >= 100 || isCanceledArray[i]
        );

        if (allDone) {
            this.doneUploading = true;
        }
        return allDone;
    }

    updateProgress = async () => {
        if (this.associatedFiles.length === 0) return;
        try{
            const projectId = this.projectStore.currentProject?.ProjectIdentifier;
            const {progressArray, statusArray, isCanceledArray, procedureNames, proceduresId} = await ProcedureRequester.getUpdatedProgress(this.generalStore.workspace, this.associatedFiles, projectId)
            this.checkIfDoneUploading(progressArray, isCanceledArray)
            if (progressArray.length > 0 ){
                this.progress = progressArray
                this.statusArray = statusArray
                this.procedureToUpload = procedureNames
                this.associatedFiles = proceduresId
                this.setProgress()
            }
        } catch {
            this.modalStore.showErrorMessage(`Error getting process updates.`)
        }
    }
    setProgress = () => {
        this.finishedFilesCount = this.progress.filter(p => p === 100).length;
        this.notCanceledFilesCount = this.progress.filter(p => !p.IsCanceled).length;
        const notCanceledOrFailed =  this.progress.filter(p => p < 101).length;
        const validProgress = this.progress.filter(p => p < 101);
        this.isFailedOrCanceledProgress = !this.progress.some(p => p < 101) && this.progress.length > 0
        const totalProgress = validProgress.reduce((sum, p) => sum + p, 0);

        this.linearLoaderValue = notCanceledOrFailed > 0
            ? Math.floor(totalProgress / (100 * notCanceledOrFailed) * 100)
            : 0;
        if(this.linearLoaderValue === 100)   {
            this.isSuccess = true
            this.doneUploading = true
            setTimeout(() => this.projectStore.refreshCurrentFolderLevel(), 1000);
        } if (this.isFailedOrCanceledProgress) {
            this.doneUploading = true
        }

    }
    resetValues = ()=>{
        this.isLoading = false
        this.progress = []
        this.statusArray = []
        this.procedureToUpload = []
        this.procedureHovered = []
        this.associatedFiles = []
        this.startUploading = false
        this.beforeUploading = true
        this.finishedFilesCount = 0
        this.notCanceledFilesCount = 0
        this.isSuccess = false
        this.doneUploading = false
        this.linearLoaderValue = 0
        this.isFailedOrCanceledProgress = false
    }
    getInitData = async(urlData) =>{
        const {db, projectId, parentFolder} = urlData

        try{
            const {progressArray, statusArray, procedureNames, proceduresId} = await ProcedureRequester.getInitConvertGuideData(db, projectId)
            if (procedureNames.length > 0 ){
                this.isLoading = true
                this.progress = progressArray
                this.statusArray = statusArray
                this.procedureToUpload = procedureNames
                this.procedureHovered = new Array(procedureNames.length).fill(false)
                this.associatedFiles = proceduresId
                this.startUploading = true
                this.setProgress()
            } else {
                this.resetValues()
            }

        } catch (err) {
            this.resetValues();
        }


    }

    checkPermission = async () => {
        try {
            this.isCheckingPermissions = true
            const workspace = this.generalStore.workspace
            const projectId = this.projectStore.currentProject?.ProjectIdentifier
            await GeneralRequester.checkPermissions(workspace, permissionsEnum.UPLOAD_GUIDE_FILE, {itemType: accessItemTypeEnum.PROJECT, projectId})
        } catch (err) {
            if ((err.response && err.response.status === 533) || err.code === 'ERR_BAD_RESPONSE') {
                this.modalStore.isUploadProcedureModalOpen = false;
                this.noPermissionModal = true
            }
        } finally {
            this.isCheckingPermissions = false
        }
    }

    closeProcess = () => {
        if (this.doneUploading){
            this.modalStore.isUploadProcedureModalOpen = false;
            this.resetValues()
        }
    }


}